__webpack_require__.p = "https://a.academia-assets.com/webpack_bundles/";